import '@/components/common/css/course/details_module.css';
import '@/components/common/css/course/details_online.css';
import api from '../../../../common/libs/api.js';
import DetailOrder from '@/components/courseCenter/detail/public/order.vue';
import Front from '@/components/courseCenter/detail/public/Front.vue';
import TalkQq from '@/components/courseCenter/detail/public/TalkQq.vue';
import {mapState} from 'vuex';

export default{
  name: 'OnlineDetail',
  data(){
    return {
    }
  },
  computed: mapState({
    city: state => state.home.city,
    content: state => state.course.courseInfo
  }),
  asyncData({store, route}){
    let city = store.state.home.city;
    let location = store.state.home.location;
    let mine = store.state.mine.state;
    let query = route.query;

    return store.dispatch('getCourseInfo', {city, location, query, mine});
  },
  watch: {
    courseInfo: {
      handler: function(newVal, oldVal){
        if (!newVal.id){
          return;
        }
        document.title = `${newVal.title  }_${  this.city.city_name  }学而思爱智康`;
      },
      deep: true
    }
  },
  components: {
    DetailOrder,
    Front,
    TalkQq
  },
  methods: {
    order(){
      if (this.content.sub_status){
        return;
      }

      this.$router.push({name: 'order', query: {
        course_id: this.content.id,
        grade: this.content.adaptive_object.split(',')[0],
        type: this.content.type,
        sub_type: this.content.sub_type,
        course_type: 100,
        name: 'online',
        category: '10001',
        teaching_mode: '1003'
      }});
    }
  },
  created(){
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
  }
}


// WEBPACK FOOTER //
// ./src/components/courseCenter/detail/online/OnlineDetail.js